import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Home, Wine, TrendingUp, User, X, ShoppingBag } from 'lucide-react';
interface DrawerMenuProps {
  isOpen: boolean;
  onClose: () => void;
  activeTab: string;
  onTabChange: (tab: string) => void;
}
interface MenuItem {
  id: string;
  label: string;
  icon: any;
}
interface MenuSection {
  title: string;
  items: MenuItem[];
}
export function DrawerMenu({
  isOpen,
  onClose,
  activeTab,
  onTabChange
}: DrawerMenuProps) {
  const menuSections: MenuSection[] = [{
    title: 'Personale',
    items: [{
      id: 'home',
      label: 'Home',
      icon: Home
    }, {
      id: 'cantina',
      label: 'La mia cantina',
      icon: Wine
    }]
  }, {
    title: 'Scopri',
    items: [{
      id: 'scopri',
      label: 'Scopri',
      icon: TrendingUp
    }, {
      id: 'acquista',
      label: 'Acquista',
      icon: ShoppingBag
    }]
  }, {
    title: 'Account',
    items: [{
      id: 'profilo',
      label: 'Profilo',
      icon: User
    }]
  }];
  const handleItemClick = (id: string) => {
    onTabChange(id);
    onClose();
  };
  return <AnimatePresence data-id="element-14">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div className="fixed inset-0 bg-black/20 z-40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-15" />

          {/* Drawer - Bordeaux Background */}
          <motion.div className="fixed top-0 left-0 bottom-0 w-72 shadow-2xl z-50 flex flex-col" style={{
        backgroundColor: '#6C083B'
      }} initial={{
        x: -288
      }} animate={{
        x: 0
      }} exit={{
        x: -288
      }} transition={{
        duration: 0.25,
        ease: [0.4, 0, 0.2, 1]
      }} data-id="element-16">
            {/* Header with Profile */}
            <div className="p-5 border-b" style={{
          borderColor: 'rgba(255, 255, 255, 0.15)'
        }} data-id="element-17">
              <div className="flex items-start justify-between mb-4" data-id="element-18">
                <div className="flex items-center gap-3" data-id="element-19">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center font-medium" style={{
                backgroundColor: '#FFFFFF',
                color: '#6C083B',
                fontSize: '15px'
              }} data-id="element-20">
                    MS
                  </div>
                  <div data-id="element-21">
                    <h3 className="mb-0.5" style={{
                  color: '#FFFFFF',
                  fontSize: '15px'
                }} data-id="element-22">
                      Mario Sommelier
                    </h3>
                    <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: '13px'
                }} data-id="element-23">
                      mario@example.com
                    </p>
                  </div>
                </div>
                <button onClick={onClose} className="p-1 -mr-1 -mt-1 transition-opacity hover:opacity-70" style={{
              color: 'rgba(255, 255, 255, 0.7)'
            }} data-id="element-24">
                  <X size={18} strokeWidth={1.5} data-id="element-25" />
                </button>
              </div>

              {/* Minimal Stats */}
              <div className="flex items-center gap-4" style={{
            color: 'rgba(255, 255, 255, 0.8)',
            fontSize: '13px'
          }} data-id="element-26">
                <div data-id="element-27">
                  <span className="font-medium" style={{
                color: '#FFFFFF'
              }} data-id="element-28">
                    127
                  </span>{' '}
                  bottiglie
                </div>
                <div className="w-px h-3" style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)'
            }} data-id="element-29" />
                <div data-id="element-30">
                  <span className="font-medium" style={{
                color: '#FFFFFF'
              }} data-id="element-31">
                    24
                  </span>{' '}
                  esperienze
                </div>
              </div>
            </div>

            {/* Menu Sections */}
            <div className="flex-1 overflow-y-auto py-2" data-id="element-32">
              {menuSections.map((section, sectionIndex) => <div key={section.title} data-id="element-33">
                  {/* Section Header */}
                  <div className="px-4 py-2" data-id="element-34">
                    <h4 className="text-xs font-medium uppercase tracking-wide" style={{
                color: 'rgba(255, 255, 255, 0.6)'
              }} data-id="element-35">
                      {section.title}
                    </h4>
                  </div>

                  {/* Section Items */}
                  <nav className="px-2" data-id="element-36">
                    {section.items.map(item => {
                const Icon = item.icon;
                const isActive = activeTab === item.id;
                return <button key={item.id} onClick={() => handleItemClick(item.id)} className="w-full mb-1 py-2.5 px-3 text-left flex items-center gap-3 rounded-lg transition-colors relative" style={{
                  backgroundColor: isActive ? 'rgba(255, 255, 255, 0.15)' : 'transparent'
                }} data-id="element-37">
                          {isActive && <div className="absolute left-0 top-1/2 -translate-y-1/2 w-0.5 h-6 rounded-r-full" style={{
                    backgroundColor: '#FFFFFF'
                  }} data-id="element-38" />}
                          <Icon size={18} style={{
                    color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.7)'
                  }} strokeWidth={1.5} data-id="element-39" />
                          <span className="text-sm" style={{
                    color: isActive ? '#FFFFFF' : 'rgba(255, 255, 255, 0.9)'
                  }} data-id="element-40">
                            {item.label}
                          </span>
                        </button>;
              })}
                  </nav>

                  {/* Divider between sections */}
                  {sectionIndex < menuSections.length - 1 && <div className="my-2 mx-4 border-t" style={{
              borderColor: 'rgba(255, 255, 255, 0.15)'
            }} data-id="element-41" />}
                </div>)}
            </div>

            {/* Footer */}
            <div className="p-4 border-t" style={{
          borderColor: 'rgba(255, 255, 255, 0.15)'
        }} data-id="element-42">
              <p className="text-center text-xs" style={{
            color: 'rgba(255, 255, 255, 0.5)'
          }} data-id="element-43">
                Versione 1.0.0
              </p>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}